import React, { useEffect, useState } from 'react'
import '../../css/Main/TopProducts.css'
import ProductCard from '../Products/ProductCard'
import axios from 'axios'
import { SpinningCircles } from 'react-loading-icons'
import { useContext } from 'react'
import { AuthContext } from '../../Context/AuthProvider';

const TopProducts = () => {
  const { user } = useContext(AuthContext);
  const [products,setProducts]=useState(null);
  useEffect(() => {
    const fetchTopProducts = async () => {
      try {
        const API = process.env.REACT_APP_BACKEND_URL;
        const params = {};
        if (user && user.id) {
          params.account_id = user.id;
        }
        const response=await axios.get(`${API}/topproducts`,{
          params
        });
        setProducts(response.data);
      } catch (error) {
        console.log(error);
      }
    }
    fetchTopProducts();
  },[])

  return (
    <div className='top-products-container'>
        <h1>Akciós Termékek</h1>
        <div className='top-products-cards'>
          {products ? (
            products.map((product) => (
              <ProductCard key={product.id} product={product}/>
            ))
          ) : (
            <div>
              <SpinningCircles />
            </div>
          )}
        </div>
    </div>
  )
}

export default TopProducts